//import {typography} from '@material-ui/core/styles';
//import {grey} from '@material-ui/core/colors';
import {grey} from '@mui/material/colors';

const styles = {
  navigation: {
    fontSize: 15,
    fontWeight: 300,
    //fontWeight: typography.fontWeightLight,
    color: grey['600'],
    paddingBottom: 15,
    display: 'block'
  },
  title: {
    fontSize: 24,
    fontWeight: 300,
    //fontWeight: typography.fontWeightLight,
    marginBottom: 20,
    color:'white'
  },
  paper: {
    padding: 30
  },
  clear: {
    clear: 'both'
  }
};

export default styles;
